import React from 'react';
import { connect } from 'react-redux';
import ClientSidebar from '../components/Element/ClientSidebar';
import Tob from '../components/Element/TobTemp';
const TobTemperory = (props) => {
	return (
		<React.Fragment>
			<div className="page-content bg-white">
				<div className="content-block">
					<div className="section-full bg-white browse-job p-t50 p-b20">
						<div className="container">
							<div className="row">
								<ClientSidebar page="tob-temp"/>
								<div className="col-xl-9 col-lg-8 m-b30 ">
									<Tob />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}


const mapStateToProps = (state) => {
  return {
    userAuth:state.auth.authUserdata
  }
}

export default connect(mapStateToProps)(TobTemperory);